// "Sync with phone" master toggle for the on-device offline alert cache.
//
// Deliberately mirrors alertPollConfig.js: tiny localStorage-backed getters/
// setters, no dependencies. This only records the user's INTENT to cache;
// the actual persistence + encryption lives in offlineAlertStore.js, and the
// two are composed by useAlerts.js (write path) and the settings UI.
//
// The toggle is inherently per-device (the cache and its key never leave the
// device), so unlike alertPollConfig there is no server mirror.

const KEY_ENABLED = 'prvsk_offline_sync_enabled';
const KEY_CAP     = 'prvsk_offline_alert_cap';

const DEFAULTS = { enabled: false, cap: 500 };

export function getOfflineSyncConfig() {
  return {
    enabled: JSON.parse(localStorage.getItem(KEY_ENABLED) ?? String(DEFAULTS.enabled)),
    cap:     JSON.parse(localStorage.getItem(KEY_CAP)     ?? String(DEFAULTS.cap)),
  };
}

export function setOfflineSyncConfig({ enabled, cap }) {
  if (enabled !== undefined) localStorage.setItem(KEY_ENABLED, JSON.stringify(!!enabled));
  if (cap     !== undefined) localStorage.setItem(KEY_CAP,     JSON.stringify(Math.max(50, cap)));
}

export function isOfflineSyncEnabled() {
  return getOfflineSyncConfig().enabled;
}

export { DEFAULTS };
